import React from 'react'
import { ThemeProvider } from 'styled-components'

import { ConfigProvider } from '@peracto/peracto-config'
import { AuthProvider, AuthConsumer } from '@peracto/peracto-auth'

import PeractoInner from './PeractoInner'
import onLoginHandler from '../../handlers/on-login'
import onLogoutHandler from '../../handlers/on-logout'

import theme, { GlobalStyle } from '../../theme'

import { ClientProvider } from '@peracto/client'
import OnApiErrorHandler from '../../handlers/on-api-error'

import { ToastContainer } from 'react-toastify'

const Peracto = ({
    config,
    onApiError = OnApiErrorHandler,
    onLogin = onLoginHandler,
    onLogout = onLogoutHandler,
    inner = PeractoInner,
    ...props
}) => {
    return (
        <ConfigProvider config={config}>
            <AuthProvider onLogin={onLogin} onLogout={onLogout}>
                <AuthConsumer>
                    {({ user }) => (
                        <ClientProvider
                            user={user}
                            entrypoint={config.get('api')}
                            onApiError={onApiError}
                        >
                            <ThemeProvider theme={theme}>
                                <GlobalStyle />
                                <ToastContainer
                                    position="top-right"
                                    className="toast-container"
                                    autoClose={5000}
                                    newestOnTop
                                    pauseOnHover={false}
                                    theme="colored"
                                    icon={false}
                                />
                                {React.createElement(inner, props)}
                            </ThemeProvider>
                        </ClientProvider>
                    )}
                </AuthConsumer>
            </AuthProvider>
        </ConfigProvider>
    )
}

export default Peracto
